import type { NormalOption, NotUndefined } from 'object-hash';
import hash from 'object-hash';
import { useMemo } from 'react';

export const useHash = (obj: NotUndefined | NotUndefined[], options?: NormalOption) =>
  useMemo(() => hash(Array.isArray(obj) ? { obj } : obj, options), [obj, options]);
